<template>
  <div>
    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
    <b-table dark striped :items="ladder" :fields="fields" :busy="isBusy" :filter="filter">
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:cell(character)="data">
        <a :href="buildHref(data)" target="_blank">{{data.item.character.name}}</a>
      </template>
      <template v-slot:cell(level)="data">{{data.item.character.level}}</template>
      <template v-slot:cell(account)="data">
        <a :href="buildAccountHref(data)" target="_blank">{{data.item.account.name}}</a>

        <template v-if="data.item.account.twitch">
          Twitch:
          <a :href="buildTwitch(data)" target="_blank">{{data.item.account.twitch.name}}</a>
        </template>
      </template>

      <template v-slot:cell(dead)="data">
        <template v-if="!data.item.dead">
          <span style="color:green">Alive</span>
        </template>
        <template v-else>
          <span style="color:red">Dead</span>
        </template>
      </template>

      <template v-slot:cell(online)="data">
        <template v-if="data.item.online">
          <span style="color:green">Online</span>
        </template>
        <template v-else>
          <span style="color:red">Offline</span>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      ladder: [],
      fields: ["rank", "dead", "online", "level", "character", "account"],
      isBusy: true,
      filter: "",
    };
  },
  mounted() {
    axios
      .get(
        `https://api.pathofexile.com/leagues/${this.$parent.league}?ladder=1&ladderLimit=50`
      )
      .then((res) => {
        this.ladder = res.data.ladder.entries;
        this.isBusy = false;
      });
  },
  methods: {
    buildHref(item) {
      let accountName = item.item.account.name;
      let charName = item.item.character.name;
      return `https://www.pathofexile.com/account/view-profile/${accountName}/characters?characterName=${charName}`;
    },
    buildAccountHref(item) {
      let accountName = item.item.account.name;
      return `https://www.pathofexile.com/account/view-profile/${accountName}`;
    },
    buildTwitch(item) {
      let twitch = item.item.account.twitch.name;
      return `https://twitch.tv/${twitch}`;
    },
  },
};
</script>

<style>
#filterInput {
  background-color: #1c2024;
  border-color: transparent;
}
</style>